import { render, staticRenderFns } from "./PaymentFailed.vue?vue&type=template&id=566c3764&scoped=true"
import script from "./PaymentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&lang=js"
import style0 from "./PaymentFailed.vue?vue&type=style&index=0&id=566c3764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c3764",
  null
  
)

export default component.exports